import {EditorContextHelper, type MagnoliaContext} from "@magnolia/vue-editor";
import {useMagnoliaSitePath} from "./use-magnolia-site-path";
import {useMagnoliaLanguages} from "./use-magnolia-languages";

export const useMagnoliaContext: () => MagnoliaContext = () => {
  const {fullPath} = useRoute();
  const runtimeConfig = useRuntimeConfig();
  const nodeName = useMagnoliaSitePath();
  const languages = useMagnoliaLanguages();
  // Match both direct start of path and with a potential intermediary path like the language
  // https://regex101.com/r/NPjHPI/2
  const REPLACE = `(^${nodeName})|(^/(${languages.join("|")})+?${nodeName})`;
  const context = EditorContextHelper.getMagnoliaContext(
    fullPath,
    REPLACE,
    languages,
  );
  return {
    ...context,
    nodePath: context.nodePath?.replace(REPLACE, nodeName),
  };
};
